import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import { ms, s, vs } from '../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { RootStackParamList } from '../../types/navigation';

type NavigationProp = NativeStackNavigationProp<RootStackParamList>;

const OnboardingChoiceScreen: React.FC = () => {
  const navigation = useNavigation<NavigationProp>();

  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <Image 
          source={require('../../assets/logo.png')}
          style={styles.logo}
          resizeMode="contain"
        />
      </View>
      <Text style={styles.title}>Welcome to FinalKey</Text>
      <Text style={styles.subtitle}>How would you like to get started?</Text>
      <TouchableOpacity
        style={styles.button}
        onPress={() => navigation.navigate('InvitationVerificationScreen')}
      >
        <Text style={styles.buttonText}>I was invited</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[styles.button, styles.createAccountButton]}
        onPress={() => navigation.navigate('SignUp')}
      >
        <Text style={[styles.buttonText, styles.createAccountButtonText]}>I want to create my own account</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F6F8',
    padding: ms(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoContainer: {
    marginBottom: ms(40),
  },
  logo: {
    width: s(125),
    height: s(125),
  },
  title: {
    fontSize: ms(28, 0.3),
    fontWeight: '600',
    color: '#1C2C4F',
    marginBottom: ms(12),
    textAlign: 'center',
  },
  subtitle: {
    fontSize: ms(18, 0.3),
    color: '#62656b',
    marginBottom: ms(40),
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#29BFC0',
    paddingVertical: ms(16),
    paddingHorizontal: ms(32),
    borderRadius: ms(30),
    width: '100%',
    marginBottom: ms(16),
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  createAccountButton: {
    backgroundColor: '#F2994A',
    borderWidth: ms(2),
    borderColor: '#F2994A',
  },
  buttonText: {
    fontSize: ms(16, 0.3),
    fontWeight: '600',
    color: '#FFFFFF',
  },
  createAccountButtonText: {
    color: '#FFFFFF',
  },
});

export default OnboardingChoiceScreen; 